import React from "react";
import { productinventoryimg } from "../../Constant/Index";
import ReUse from "../../services/helpers/reUse";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import AppService from "../../services/appServices";
import { toast } from "react-toastify";
import {
	clearResponseMessageAfterDelay,
	errorMessage,
	successMessage,
} from "../../redux/slices/responseMessage.slice";
import CustomImage from "../../Components/ReUse/Components/Image";

const SellerProductInventoryCard = (propsData) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const [loading, setLoading] = useState(false);
	const [statusMessage, setStatusMessage] = useState("");

	const {
		added_by,
		after_discount_price,
		amazon_coupon_code,
		amazon_coupon_discount,
		amazon_coupon_discount_type,
		amazon_coupon_expiry,
		amazon_link,
		attachment,
		attributes,
		average_rating,
		boost,
		boost_expiry,
		brand_id,
		category_ids,
		choice_options,
		colors,
		created_at,
		current_stock,
		details,
		discount,
		discount_type,
		expiry_date,
		featured,
		featured_status,
		flash_deal,
		free_shipping,
		id,
		images,
		min_qty,
		moq_selling,
		name,
		product_type,
		published,
		purchase_price,
		refundable,
		slug,
		status,
		tax,
		tax_type,
		thumbnail,
		thumbnail_path,
		unit,
		unit_price,
		unit_weight,
		updated_at,
		user_id,
		variant_product,
		variation,
		video_provider,
		video_url,
	} = propsData ?? {};

	const handleDeleteProduct = async (e) => {
		e.preventDefault();

		const isConfirmed = await ReUse.showConfirmationDialog({});

		if (!isConfirmed) {
			ReUse.showSuccessDialog({});
			setLoading(false);
			return;
		}

		try {
			setLoading(true);
			const apiResp = await AppService.sellerDeleteProduct({ productId: id });
			const { message, response } = apiResp.data;
			dispatch(successMessage(message));
			ReUse.showSuccessDialog({ text: message });
			setTimeout(() => {
				dispatch(successMessage("Navigating..."));
				setTimeout(() => {
					dispatch(successMessage(""));
				}, 1000);
			}, 1000);
		} catch (err) {
			setLoading(false);
			const errorMessage = err?.response?.data?.message || "An error occurred.";
			dispatch(errorMessage);
			dispatch(clearResponseMessageAfterDelay());
			dispatch(successMessage(""));
			ReUse.showErrorDialog({ text: errorMessage });
		} finally {
			setLoading(false);
		}
	};

	const discountPrice =
		discount > 0
			? discount_type === "amount"
				? unit_price - discount
				: (unit_price * discount) / 100
			: unit_price;

	return (
		<tr>
			<td>
				<h5>{name}</h5>
			</td>
			<td className="inventry-img">
				<figure>
					<CustomImage thumbnail={thumbnail} />
				</figure>
			</td>
			<td className="product-inventory-para">
				<p>{ReUse.removeHTMLTags({ unStripped: details })}</p>
			</td>
			<td>
				<h5>{"category_name"}</h5>
			</td>
			<td>
				<h5>{"sub_category_name"}</h5>
			</td>
			<td>
				<h5>${unit_price}</h5>
			</td>
			<td className="product-inventory-btn">
				<div className="product-inventory-all">
					<button className={status !== 1 ? "inactive" : ""}>
						{status === 1 ? "Active" : "Inactive"}
					</button>
				</div>
			</td>
			<td className="stock-img">
				<p>
					{current_stock ? "In Stock" : "Not In Stock"}
					<span>
						<i class="fa fa-check-circle" aria-hidden="true"></i>
					</span>
				</p>
			</td>
			<td className="delete-trash">
				<i
					class="fa fa-trash-o"
					aria-hidden="true"
					onClick={(e) => handleDeleteProduct(e)}
				></i>
			</td>
			<td className="edit-screen">
				<Link to={`/seller-update-product/${slug}`}>
					<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
				</Link>
			</td>
			<td className="price-para">
				<p>{min_qty}</p>
			</td>
			<td className="price-para">
				<p>${discountPrice}</p>
			</td>
		</tr>
	);
};

export default SellerProductInventoryCard;
